export function showCoinAwardToast(notifySuccess, coinAward) {
    if (!coinAward?.awarded || typeof notifySuccess !== 'function') {
        return;
    }

    notifySuccess(coinAward.message || `+${coinAward.amount} collector coins`, {
        title: 'Collector coins',
        // Short-lived so it doesn't cover phone UI (back button / hero) for long
        duration: 2500,
    });
}

const PENDING_COIN_AWARD_KEY = 'msv-pending-coin-award';

/** Queue a coin toast across a full page navigation (e.g. upload redirect). */
export function queueCoinAwardToast(coinAward) {
    if (!coinAward?.awarded) return;
    try {
        sessionStorage.setItem(PENDING_COIN_AWARD_KEY, JSON.stringify(coinAward));
    } catch {
        // Ignore storage failures; award still happened server-side.
    }
}

/** Show and clear any queued coin toast. Call once on pages that receive redirects. */
export function flushPendingCoinAwardToast(notifySuccess) {
    let raw;
    try {
        raw = sessionStorage.getItem(PENDING_COIN_AWARD_KEY);
        if (!raw) return;
        sessionStorage.removeItem(PENDING_COIN_AWARD_KEY);
    } catch {
        return;
    }

    try {
        showCoinAwardToast(notifySuccess, JSON.parse(raw));
    } catch {
        // Ignore malformed payload.
    }
}

export const COLLECTOR_REWARD_RULES = [
    { action: 'Upload a collectible', coins: 25, cap: 'Once per item' },
    { action: 'List an item on the marketplace', coins: 25, cap: 'Once per item' },
    { action: 'Like another collector\'s item', coins: 1, cap: 'Up to 10/day' },
    { action: 'View another collector\'s item', coins: 1, cap: 'Up to 10/day' },
    { action: 'Comment on an item', coins: 3, cap: 'Up to 5/day' },
    { action: 'Mark a marketplace listing as sold', coins: 100, cap: 'Up to 2/day' },
];
